// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"style__backdrop__i4ppV","content":"style__content__tqsle","header":"style__header__2QFn-","body":"style__body__LV2ZB","footer":"style__footer__r67tv"};